module.exports = __webpack_public_path__ + "img/resource_2.bc8adaf4.png";